import type { ConsentCategory } from '@schibsted/sourcepoint';

export const ALL_CATEGORIES: ConsentCategory[] = [
  'CMP:analytics',
  'CMP:marketing',
  'CMP:advertising',
  'CMP:personalisation',
  // "CMP:performance_marketing",
];
